import { translate } from '@jsverse/transloco';
export enum Language {
    EN = 'en',
    FR = 'fr',
    ES = 'es',
}

export class LanguageHelper {
    static getLanguageLocale(language?: Language): string {
        switch (language) {
            case Language.EN:
                return translate('LANGUAGE.ENGLISH');
            case Language.FR:
                return translate('LANGUAGE.FRENCH');
            case Language.ES:
                return translate('LANGUAGE.SPANISH');
            default:
                return '';
        }
    }
}
